import Box from "@mui/material/Box";
import * as React from "react";

type AppNavTopbarProps = {
  children: React.ReactNode;
};

export default function AppNavTopbar({ children }: AppNavTopbarProps) {
  return (
    <Box
      component="nav"
      className="absolute w-full h-16 flex items-center justify-between p-4"
    >
      <div className="justify-start h-full relative z-[100]">{children}</div>
    </Box>
  );
}
